import React, { useState } from 'react';
import Navbar from '../../../components/navbar'
import Footer from '../../../components/footer';
import { FaPencilAlt, FaSearch, FaComments, FaCommentDots } from 'react-icons/fa'

export default function PtBr(params) {
  const [showAsk1, setShowAsk1] = useState(false)
  const [showAsk2, setShowAsk2] = useState(false)


  return (
    <div>
      <Navbar lang={'pt'}/>
      <main className='flex mt-28 flex-col '>
        <section className='bg-danger mb-4 bg-opacity-15'>
          <p className='text-warning font-medium text-lg lg:w-4/6 md:w-5/6 w-11/12 m-auto p-4 text-center'> 
            Prezado(a) relatante, informamos que o Canal de Ouvidoria da Mig-PLUS encontra-se em fase de transição.
            Recomendamos que novos registros sejam realizados diretamente na Linha Aberta de Ética (Ethics Open Line - EOL) da Cargill,
            por meio do link <a href="https://cargill.navexone.com/intake/" target="_blank" rel="noopener noreferrer" className='font-bold '>https://cargill.navexone.com/intake/</a> ou pelo telefone <b>0800-000-2756</b>.
            Em caso de dúvidas ou dificuldades de acesso ao novo canal, entre em contato com o Comitê de Ética da Mig-PLUS para obter
            o devido suporte. Atenciosamente!
          </p>
        </section>
        <section className='lg:w-4/6 md:w-5/6 w-11/12 m-auto'>
          <div className='gap-2 flex flex-col text-secondary font-medium'>
            <h1 className='text-primary flex items-center gap-4 text-2xl font-bold mb-8'><FaComments size={`2.5rem`} /> OUVIDORIA</h1>
            <p>Sejam bem-vindo(a)</p>
            <p>Este é um canal exclusivo da Mig-PLUS, para comunicação segura sobre violações de ética, denúncias de irregularidades internas e externas, garantindo o anonimato do relatante e a confidencialidade das questões tratadas.</p>
            <p>Não serão admitidas retaliações a quem, de boa-fé, comunique alguma violação de conduta.</p>
            <p>Ao fazer uso desses canais, tenha uma atitude ética. Aja com responsabilidade!</p>
            <p><b>Consumidor:</b> para dúvidas, solicitação, elogios, sugestão ou reclamação em relação aos produtos, utilize nosso <b>SAC: 0800-97-96876</b> ou <b>+ 55 (54) 3347-3100</b>.</p>
          </div>
        </section>
        <section className='mt-12 mb-12 bg-background'>
          <div className='lg:w-4/6 md:w-5/6 w-11/12 m-auto p-8 flex flex-col'>
            <h2 className='text-center text-primary text-2xl font-bold'>Escolha uma das opções abaixo</h2>
            <div className='flex gap-8 justify-evenly mt-8 flex-col md:flex-row'>
              <span className='opacity-50 cursor-not-allowed bg-white px-16 py-8 border text-primary rounded-lg font-bold text-xl uppercase flex gap-4 select-none'>
                <FaPencilAlt size={'2rem'}/>
                Realizar relato
              </span>
              <a className='bg-white px-16 py-8 border text-primary shadow-xl rounded-lg font-bold text-xl hover:bg-primary hover:text-white uppercase flex gap-4' href="/follow">
                <FaSearch size={'2rem'}/>
                Acompanhar relato
              </a>
            </div>
          </div>
        </section>
        <section className='lg:w-4/6 md:w-5/6 w-11/12 m-auto'>
          <div>
            <h1 className='text-4xl flex items-center gap-4 text-primary mb-8'><FaCommentDots/> Perguntas Frequentes</h1>
            <div className='rounded-md border border-background mb-8 shadow-md' >
              <button onClick={() => setShowAsk1(!showAsk1)} className='text-2xl bg-background w-full p-4 text-start text-secondary rounded-t-md'>Como funciona a Ouvidoria?</button>
              {showAsk1 &&
                <div className='m-4 flex flex-col gap-4 text-secondary font-medium text-lg'>
                  <p>A ouvidoria funciona da seguinte maneira:</p>
                  <ul>
                    <li>Recebimento;</li>
                    <li>Tratativa;</li>
                    <li>Resposta</li>
                  </ul>
                  <p><b>Recebimento:</b> o cliente envia o relato no nosso site.</p>
                  <p><b>Tratativa:</b> nossa equipe avalia e realiza os encaminhamentos necessários referente ao relato recebido do nosso site.</p>
                  <p><b>Resposta:</b> a equipe envia ao cliente uma resposta através do acompanhamento do seu relato no site.</p>
                </div>
              }
            </div>
            <div className='rounded-md border border-background mb-8 shadow-md'>
              <button onClick={() => setShowAsk2(!showAsk2)} className='text-2xl bg-background w-full p-4 text-start text-secondary rounded-t-md'>Quando serei atendido?</button>
              {
                showAsk2 &&
                <div className='m-4 flex flex-col gap-4 text-secondary font-medium text-lg'>
                  <p>O tempo médio de resposta ao relato recebido é de 48h.</p>
                </div>
              }
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  )
};
